export default "/_next/static/chunks/fonts/WhitneySSm-Semibold-Pro_Web-9e41a7e2514a1f2656d17c1040e480df.woff2";